import { render } from "./TransactionTaggingModal.vue?vue&type=template&id=7db8a125&scoped=true"
import script from "./TransactionTaggingModal.vue?vue&type=script&lang=js"
export * from "./TransactionTaggingModal.vue?vue&type=script&lang=js"

import "./TransactionTaggingModal.vue?vue&type=style&index=0&id=7db8a125&scoped=true&lang=css"
import "./TransactionTaggingModal.vue?vue&type=style&index=1&id=7db8a125&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db8a125"]])

export default __exports__